import { IFee } from "../../models/IFee";

export class FeeState {
  feeList: IFee[] = [];
}
